export default {"src":"/_next/static/media/close.f2f7bb37.svg","height":24,"width":24};